import {
    collection,
    getVariantByParentType,
    globalCounterPath,
    parentTypeFor,
    readGlobalCount,
    refs,
} from "../_variants/index.js";
import {
    makeAttached,
    makeDropdown,
    pad
} from "../../../utils.js";

export const addConcession = ({ form, pageItem, store, attachedItems, meta }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? pageItem?.ParentType);
    const conCollection = collection(variant, "Concessions");
    const conCollectionTail = parentTypeFor(variant, "Concessions");
    const conRefs = refs(variant, "Concessions");
    const docCollection = collection(variant, "Documents");
    const docCollectionTail = parentTypeFor(variant, "Documents");
    const drawingCollection = collection(variant, "Drawings");
    const drawingCollectionTail = parentTypeFor(variant, "Drawings");
    const effectivityCollection = "Database/Effectivities";
    const effectivityCollectionTail = "Effectivities";
    const conParentType = parentTypeFor(variant, "Concessions");
    const counterPath = globalCounterPath(variant, "counts/database/concession/count");

    form.setConfig({
        "title": "Add Concession",
        "type": "push",
        "location": conCollection,
        "fields": [{
            "label": "Number",
            "type": "value",
            value() {
                return `${variant.docPrefix}CON-${pad(readGlobalCount(store, variant, ["database", "concession"]))}`
            }
        }, {
            "label": "Comment",
            "name": "Comment",
            "type": "text",
            "divClass": "col-span-2"
        }, {
            "label": "Select Documents",
            "name": docCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[docCollectionTail].items, "Number", "ID")
        }, {
            "label": "Select Drawings",
            "name": drawingCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[drawingCollectionTail].items, "Number", "ID")
        }, {
            "label": "Select Effectivities",
            "name": effectivityCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[effectivityCollectionTail].items, "Number", "ID")
        }],
        async preSubmitHook({ data, db }) {
            const number = await db.utils.allocateCount(counterPath);
            return {
                "Date": {
                    "Created": new Date().toISOString(),
                    "Cancelled": "N/A",
                    "Signedoff": "N/A"
                },
                "Cancelled": false,
                "Signedoff": false,
                "Author": store.getters.userName,
                "Parent": pageItem.Number,
                "ParentID": pageItem.ID,
                "Aircraft": pageItem.Aircraft,
                "ParentType": meta.ParentType,
                "Number": `${variant.docPrefix}CON-${pad(number)}`,
                [docCollectionTail]: makeAttached(data[docCollectionTail]),
                [drawingCollectionTail]: makeAttached(data[drawingCollectionTail]),
                [effectivityCollectionTail]: makeAttached(data[effectivityCollectionTail])
            }
        },
        postSubmitHook({ db, data, typeRef }) {
            data.ID = typeRef.key;
            db.set(`Database/${meta.ParentType}/${pageItem.ID}/${conCollectionTail}/${data.ID}`, true);
            db.utils.addAllTo(data, docCollection, docCollectionTail, conParentType);
            db.utils.addAllTo(data, drawingCollection, drawingCollectionTail, conParentType);
            db.utils.addAllTo(data, effectivityCollection, effectivityCollectionTail, conParentType);
            db.utils.updateRefs(data, conRefs, ["Number", "ID", "Comment", "Signedoff", "Date", "Parent", "ParentID"]);
        }
    });
    form.getDropdownData();
    form.toggle();
};

export const editConcession = async ({ form, item, attachedItems, store, meta, pageItem }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? item?.ParentType ?? pageItem?.ParentType);
    const conCollection = collection(variant, "Concessions");
    const conRefs = refs(variant, "Concessions");
    const docCollection = collection(variant, "Documents");
    const docCollectionTail = parentTypeFor(variant, "Documents");
    const drawingCollection = collection(variant, "Drawings");
    const drawingCollectionTail = parentTypeFor(variant, "Drawings");
    const effectivityCollection = "Database/Effectivities";
    const effectivityCollectionTail = "Effectivities";
    const conParentType = parentTypeFor(variant, "Concessions");

    form.setValues({
        "Comment": item.Comment,
        [docCollectionTail]: Object.keys(item[docCollectionTail] || {}),
        [drawingCollectionTail]: Object.keys(item[drawingCollectionTail] || {}),
        [effectivityCollectionTail]: Object.keys(item[effectivityCollectionTail] || {})
    });
    form.setConfig({
        "title": "Update Concession",
        "type": "update",
        "location": `${conCollection}/${item.ID}`,
        "set": true,
        "fields": [{
            "label": "Comment",
            "name": "Comment",
            "type": "text",
            "divClass": "col-span-3"
        }, {
            "label": "Select Documents",
            "name": docCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[docCollectionTail].items, "Number", "ID")
        }, {
            "label": "Select Drawings",
            "name": drawingCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[drawingCollectionTail].items, "Number", "ID")
        }, {
            "label": "Select Effectivities",
            "name": effectivityCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[effectivityCollectionTail].items, "Number", "ID")
        }],
        preSubmitHook({ data }) {
            return {
                [docCollectionTail]: makeAttached(data[docCollectionTail]),
                [drawingCollectionTail]: makeAttached(data[drawingCollectionTail]),
                [effectivityCollectionTail]: makeAttached(data[effectivityCollectionTail])
            }
        },
        postSubmitHook({ db, data }) {
            db.utils.addAllTo(data, docCollection, docCollectionTail, conParentType);
            db.utils.addAllTo(data, drawingCollection, drawingCollectionTail, conParentType);
            db.utils.addAllTo(data, effectivityCollection, effectivityCollectionTail, conParentType);
            db.utils.updateRefs(data, conRefs, ["Number", "ID", "Comment", "Signedoff", "Date", "Parent", "ParentID", "Title"]);
        }
    });
    await form.getDropdownData();
    
    form.toggle();
};

export const cancelConcession = ({ form, item, meta, pageItem }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? item?.ParentType ?? pageItem?.ParentType);
    const conCollection = collection(variant, "Concessions");
    const conRefs = refs(variant, "Concessions");

    form.setConfig({
        "title": "Cancel Concession",
        "description": `Are you sure you want to cancel Concession ${item.Number}?`,
        "type": "update",
        "location": `${conCollection}/${item.ID}`,
        "fields": [],
        preSubmitHook(){
            return {
                "Cancelled": true,
                "Date/Cancelled": new Date().toISOString()
            }
        },
        async postSubmitHook({ db, data }) {
            await db.utils.updateRefs({ ...item, ...data, "ID": item.ID }, conRefs, ["Number", "ID", "Comment", "Signedoff", "Date", "Parent", "ParentID"]);
        }
    });
    form.toggle();
};

export const signoffConcession = ({ form, item, meta, pageItem }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? item?.ParentType ?? pageItem?.ParentType);
    const conCollection = collection(variant, "Concessions");
    const conRefs = refs(variant, "Concessions");

    form.setConfig({
        "title": "Signoff Concession",
        "description": `Are you sure you want to signoff Concession ${item.Number}?`,
        "type": "update",
        "location": `${conCollection}/${item.ID}`,
        "fields": [],
        preSubmitHook() {
            return {
                "Signedoff": true,
                "Date/Signedoff": new Date().toISOString()
            }
        },
        postSubmitHook({ db, data }) {
            db.utils.updateRefs(data, conRefs, ["Number", "ID", "Comment", "Signedoff", "Date", "Parent", "ParentID"]);
        }
    });
    form.toggle();
};

export const linkConcession = ({ form, pageItem, meta }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? pageItem?.ParentType);
    const conCollection = collection(variant, "Concessions");
    const conRefs = refs(variant, "Concessions");

    form.setConfig({
        "title": "Link Concession",
        "type": "update",
        "location": `Database/${meta.ParentType}/${pageItem.ID}`,
        "fields": [{
            "label": "Concession",
            "name": "Concession",
            "type": "dropdown",
            "labelKey": "Number",
            "idKey": "ID",
            "dataLocation": conRefs
        }],
        preSubmitHook({liveInputData}) {
            return {
                "Concession": null,
                [`Concessions/${liveInputData.Concession}`]: true
            }
        },
        postSubmitHook({ db, liveInputData }) {
            db.update(`${conCollection}/${liveInputData.Concession}/${meta.ParentType}/${pageItem.ID}`, true);
        }
    });
    form.getDropdownData();

    form.toggle();
};

